module.exports = __webpack_public_path__ + "static/FoundersGrotesk-Regular-50edaaf5f2e8a63fc530a04e519b5e3e.woff2";